import {getCourseWithTeacher, enrolledStudentList, getStudentList} from '@/api/attendance'

export const attendanceMixin = {
  data () {
    return {
      courseList:[],
      selectedCourseId:null,
      teacherList:[],
      studentList:[],
      students:[],
      studentId:null,
      teacherId:null,
      attendance_date:new Date(),
      attendanceTypeOptions:['All', 'Marked', 'UnMarked'],
      attendanceType:'All'
    }
  },
  created () {
    this.fetchTeacherWithList()
    this.fetchStudentList()

  },
  methods:{
    async fetchEnrolled (payload) {
      try {
        const platform_customer_id = localStorage.getItem('customer_id')
        const {data} = await enrolledStudentList(platform_customer_id, payload)
        
        this.studentList = data.data.student_list
        
        
        // this.studentAttendanceList = await this.structuredStandardList(this.studentList)
        this.fetchScheduleCourseDate(payload)
        
      } catch (error) {
        console.warn(error)
      }
    },
    async fetchTeacherWithList () {
      
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          schedule:true
        }
        const {data} = await getCourseWithTeacher(customer_id, payload)
          
        this.courseList = data.data.course_list
          
      } catch (error) {
        console.warn(error)
      }
    },
    async fetchStudentList () {

      try {
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await getStudentList(customer_id)
        this.students = data.data.clientUser
        console.log(data)
      } catch (error) {
        console.warn(error)
      }

    }
  },
  watch:{
    selectedCourseId () {
      const selectedCourse = this.courseList.filter(ele => {
        return ele.id === this.selectedCourseId
      })
      console.log(selectedCourse)
      this.teacherId = null
      
      if (selectedCourse.length > 0) {
        this.teacherList = selectedCourse[0].instructors
        this.teacherId = this.teacherList[0].id
      }
    },
    filterPayload:{
      deep:true,
      handler () {
        console.log('Handler')
      }
    }
  }
}